// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3psTY","toggleWrap":"styles_toggleWrap__1NsXv","content":"styles_content__1uLp0","selectAreaCode":"styles_selectAreaCode__2bQ7G"};